import * as React from "react";
import { observer } from "mobx-react-lite";
import { MultiStepTask } from "src/components/MultiStepTask";
import { t } from "i18next";
import { MultiStepTaskStore } from "src/components/MultiStepTask/MultiStepTaskStore";
import { MultiStepItem } from "src/components/MultiStepTask/MultiStepItem";
import {
  lastStep,
  nextStep,
  prevStep,
} from "src/components/MultiStepTask/utils";
import { EntityFiltersTable } from "src/pages/EntityFiltersPage/EntityFiltersTable";
import { AsyncTable } from "src/components/tables/AsyncTable";
import { selectOnRowClick } from "src/components/tables/selectOnRowClick";
import { bom3ControlStore } from "../Bom3ControlStore";
import { Bom3CopyFromStore } from "./Bom3CopyFromStore";

type PropsBom3CopyFrom = {
  copyStore: Bom3CopyFromStore | null;
};

export const Bom3CopyFrom: React.FC<PropsBom3CopyFrom> = observer((props) => {
  const { copyStore } = props;
  const taskStore = React.useMemo(() => new MultiStepTaskStore(), []);

  React.useEffect(() => {
    if (copyStore) {
      taskStore.open();
    } else if (taskStore.isOpen) {
      taskStore.close();
    }
  }, [copyStore]);

  React.useEffect(() => {
    if (!taskStore.isOpen && copyStore) {
      copyStore.params.close();
    }
  }, [taskStore.isOpen]);

  const steps: MultiStepItem[] = copyStore
    ? [
        {
          title: "Модель",
          description: "Выберите экземпляр-источник для копирования",
          next: nextStep(copyStore.firstDisabled),
          drawContent: () => <EntityFiltersTable store={copyStore.store1} />,
        },
        {
          title: "BOM",
          description: "Выберите данные для копирования",
          prev: prevStep(),
          next: nextStep(copyStore.secondDisabled),
          drawContent: () => {
            const { store2 } = copyStore;
            if (!store2) return null;
            return (
              <AsyncTable
                store={store2}
                columns={bom3ControlStore.columns}
                onRowClick={(row) => selectOnRowClick(row, store2)}
              />
            );
          },
        },
        lastStep(t("Copying"), copyStore.copyInfo, () => copyStore.copy()),
      ]
    : [];

  return (
    <MultiStepTask title={t("Copy from")} taskStore={taskStore} steps={steps} />
  );
});
